<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">

      <v-data-table :headers="headers" :items="result_class_list" class="elevation-1 mytable" dense :search="search">

        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Result Class Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"></span>

          <v-row dense align="center">
            
            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn
                rounded
                color="success"
                outlined
                :loading="loader"
                @click="downloadFile"
              >
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details />
            </v-col>

            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" small v-on="on">
                  Add Result Class
                </v-btn>
              </template>

              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text class="pb-2 mt-2">
                    <v-col cols="12">
                        <v-icon color="error" small>*</v-icon>
                        <v-text-field label="Min Percentage" v-model="minValue" outlined type="number" />

                        <v-icon color="error" small>*</v-icon>
                        <v-text-field label="Max Percentage" v-model="maxValue" outlined type="number" />

                        <v-icon color="error" small>*</v-icon>
                        <v-text-field label="Enter Result Name" v-model="name" outlined />

                        <v-checkbox dense v-model="editedItem.isactive" color="success" label=" Is Active" v-if="editedIndex !== -1"
                            class="ml-4"></v-checkbox>
                  </v-col>
                  </v-card-text>

                  <v-card-actions class="justify-center pt-0">
                    <v-btn class="button" @click="close()" :disabled="!valid">
                       Cancel
                    </v-btn>

                    <v-btn color="primary button" @click="save" :disabled="!valid">
                        {{ editedIndex === -1 ? 'Save' : 'Update' }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>

        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>

            <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:item.isactive="{ item }">
          <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    name: "",
    minValue:"",
    maxValue:"",
    dialog: false,
    headers: [
      {
        text: "Min Percentage",
        align: "left",
        sortable: false,
        value: "minValue",
      },
      {
        text: "Max Percentage",
        align: "left",
        sortable: false,
        value: "maxValue",
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Is Active",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { 
        text: " Actions", 
        value: "action", 
        sortable: false 
      },
    ],
    result_class_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      minValue:"",
      maxValue:"",
      isactive: true
    },
    defaultItem: {
      id: "",
      name: "",
      minValue:"",
      maxValue:"",
      isactive: true
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Result Class" : "Edit Result Class";
    },
    filteredRuleList() {
        if (!this.search) return this.result_class_list;

        const txt = this.search.toLowerCase();

        return this.result_class_list.filter(item => (item.name || "").toLowerCase().includes(txt)
    );
  }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    downloadFile() {
    this.loader = true;

    const excelData = this.filteredRuleList.map((item, index) => ({
      "S.No": index + 1,
      "Min": item.minValue,
      "Max": item.maxValue,
      "name": item.name,
      "Is Active": item.isactive
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Result Class");
    XLSX.writeFile(workbook, "ResultClass.xlsx");

    this.loader = false;
  },

    editItem(item) {
      this.editedIndex = this.result_class_list.indexOf(item);
      this.editedItem= {
        id : item.id,
        name : item.name,
        minValue : item.minValue,
        maxValue: item.maxValue,
        isactive : item.isactive
      };
      this.name = item.name;
      this.minValue = item.minValue;
      this.maxValue = item.maxValue;
      this.isactive = item.isactive;
      this.dialog = true;
    },

    onLoad() {
      this.overlay = true;
      this.name="";
      axios
        .post("/examination/getResultClass")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            this.result_class_list = res.data.result_class_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      this.name="";
      this.minValue="";
      this.maxValue="";
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
              if(this.name){
                this.editedItem.name = this.name;
                this.editedItem.minValue = this.minValue;
                this.editedItem.maxValue = this.maxValue;
              }else{
                 this.showSnackbar("#b71c1c", "Enter Valid Name");
                 return
              }    
          axios
            .post("/examination/editResultClass", this.editedItem)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                this.showSnackbar("#4caf50", "Result Class Updated Successfully...");
                this.close();
                this.onLoad();
              } else if (res.data.code == "NA") {
                this.showSnackbar("#b71c1c", res.data.msg || "Result Class Already Present!!!");
              } else {
                this.showSnackbar("#b71c1c", "Something went wrong!");
                sessionStorage.setItem("error-trace", res.data.error_trace);
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
        }
      } else {
        if(this.name){
        const payload = {
          name: this.name,
          minValue: this.minValue,
          maxValue: this.maxValue
        }
        axios
          .post("/examination/saveResultClass", payload)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              this.showSnackbar("#4caf50", "Result Class Added Successfully...");
              this.onLoad();
            } else if (res.data.code == "NA") {
              this.showSnackbar("#b71c1c", res.data.msg || "Result class Already Present!!!");
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
          this.close();
        }else{
          this.showSnackbar("#b71c1c", "Enter All Fields...");
        }
      }
    }, 

    isValidated() {
      if (this.name && this.minValue && this.maxValue) {
        return true;
      } else {
        if (!this.editedItem.name || this.editedItem.min || this.editedItem.max) {
          this.errorMsg.name = true;
        }
        return false;
      }
    }, 

    toggle(item) {
      const data = {
        id: item.id,
        toggle: item.isactive,
      };
      this.overlay = true;
      axios
        .post("/examination/toggleResultClass", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Result Class Updated Successfully!");
          } else if (res.data.code == "NA") {
            this.showSnackbar("#4caf50","Something went wrong, Please try again later!");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this result class?")) {
      const data = {
        id: item.id
      };
      axios
        .post("/examination/deleteResultClass", data)
        .then((res) => {
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Result Class Deleted Successfully...");
            this.onLoad();
          } else {
            this.showSnackbar("#b71c1c", res.data.msg || "Something went wrong!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
      }
      this.close();
    }
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.mytable /deep/ thead th {
  background: #0f2027;
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>